"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _ = require("../..");
var _DndProvider = _interopRequireDefault(require("../DndProvider/DndProvider"));
var _broadcastSourceHelper = require("../../utils/broadcastSourceHelper");
var _propComparators = require("../../utils/propComparators");
var _useLazyLoading2 = require("../../hooks/useLazyLoading");
var _LazyLoader = require("../../constants/LazyLoader");
var _elementErrorBoundaryPropsHelper = require("../../utils/elementErrorBoundaryPropsHelper");
var _ComponentTypes = require("../../constants/ComponentTypes");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _SourceListItem = _interopRequireDefault(require("./SourceListItem"));
var _SourceList = require("./SourceList.styled");
var _MediaPlayerSettingsPropType = _interopRequireDefault(require("../MediaPlayerSettingsPropType"));
var _SourceListDnd = _interopRequireDefault(require("./SourceListDnd"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SourceList = function SourceList(_ref) {
  var enableFeature = _ref.enableFeature,
    isDraggingSource = _ref.isDraggingSource,
    tab = _ref.tab,
    sources = _ref.sources,
    onSourceSetToLive = _ref.onSourceSetToLive,
    onSourceEdited = _ref.onSourceEdited,
    onSourceDeleted = _ref.onSourceDeleted,
    onFeaturedToggleClicked = _ref.onFeaturedToggleClicked,
    onMuteToggleClicked = _ref.onMuteToggleClicked,
    onLiveToggleClicked = _ref.onLiveToggleClicked,
    onLoopToggleClicked = _ref.onLoopToggleClicked,
    liveSources = _ref.liveSources,
    onSourceHidden = _ref.onSourceHidden,
    mediaPlayerSettings = _ref.mediaPlayerSettings,
    onVolumeChanged = _ref.onVolumeChanged,
    isMaxUnhiddenCamerasOn = _ref.isMaxUnhiddenCamerasOn,
    attendeeCameraStatus = _ref.attendeeCameraStatus,
    onCameraToggleClicked = _ref.onCameraToggleClicked,
    isMaximumCameraSourcesOn = _ref.isMaximumCameraSourcesOn,
    stagedSources = _ref.stagedSources,
    onSourceStaged = _ref.onSourceStaged,
    isStagedSourcesActive = _ref.isStagedSourcesActive,
    onReorderSources = _ref.onReorderSources,
    onDragSource = _ref.onDragSource,
    onThumbnailReady = _ref.onThumbnailReady,
    onUploadClicked = _ref.onUploadClicked,
    onSetSourceUnassigned = _ref.onSetSourceUnassigned,
    user = _ref.user,
    viewPermissions = _ref.viewPermissions,
    attendeeTiles = _ref.attendeeTiles,
    meetingSession = _ref.meetingSession,
    params = _ref.params,
    attendeeId = _ref.attendeeId,
    onAssignSpeakers = _ref.onAssignSpeakers,
    onReplaceSlides = _ref.onReplaceSlides,
    onPdfAssignClicked = _ref.onPdfAssignClicked,
    onPresentationLoadSuccess = _ref.onPresentationLoadSuccess,
    onGoToPresentationPage = _ref.onGoToPresentationPage,
    layout = _ref.layout;
  var isStudioLite = (0, _hooks.useStudioLiteContext)();
  var sourceListRef = (0, _react.useRef)(null);
  var _useLazyLoading = (0, _useLazyLoading2.useLazyLoading)(_LazyLoader.SOURCES_ID_PREFIX),
    visibleItemsMap = _useLazyLoading.visibleItemsMap,
    registerLazyLoadedContainer = _useLazyLoading.registerLazyLoadedContainer,
    updateItems = _useLazyLoading.updateItems;
  var emptyText = 'No sources available';
  var errorBoundaryProps = (0, _elementErrorBoundaryPropsHelper.getElementErrorBoundaryProps)(_ComponentTypes.SOURCE);
  (0, _react.useEffect)(function () {
    if (sourceListRef.current) {
      registerLazyLoadedContainer(sourceListRef);
    }
  }, [sourceListRef, registerLazyLoadedContainer]);
  (0, _react.useEffect)(function () {
    updateItems(sources);
  }, [sources, updateItems]);
  var checkCameraIsOn = (0, _react.useCallback)(function (sourceValue) {
    var _attendeeCameraStatus;
    return (_attendeeCameraStatus = attendeeCameraStatus[sourceValue]) !== null && _attendeeCameraStatus !== void 0 ? _attendeeCameraStatus : false;
  }, [attendeeCameraStatus]);
  var hasSources = (0, _react.useMemo)(function () {
    return !!(sources !== null && sources !== void 0 && sources.length);
  }, [sources]);
  var displayListComponent = (0, _react.useCallback)(function (errorBoundaryProps) {
    return sources.map(function (s, idx) {
      return _react["default"].createElement(_.ElementErrorBoundary, (0, _extends2["default"])({
        key: s._id
      }, errorBoundaryProps), _react["default"].createElement(_SourceListItem["default"], {
        index: idx,
        enableFeature: enableFeature,
        dragAndDrop: true,
        live: liveSources.includes(s._id),
        loop: (0, _typeof2["default"])(s.value) === 'object' && s.value.loop,
        volume: (mediaPlayerSettings[s._id] || {}).volume,
        onLiveClicked: onSourceSetToLive.bind(null, s),
        onSourceEdited: onSourceEdited.bind(null, s),
        onSourceDeleted: onSourceDeleted.bind(null, s),
        onSourceHidden: onSourceHidden.bind(null, s),
        onFeaturedToggleClicked: onFeaturedToggleClicked.bind(null, s),
        onMuteToggleClicked: onMuteToggleClicked.bind(null, s),
        onLiveToggleClicked: onLiveToggleClicked.bind(null, s),
        onLoopToggleClicked: onLoopToggleClicked.bind(null, s),
        onVolumeChanged: onVolumeChanged.bind(null, s),
        key: "sourceListItem-".concat(s._id),
        source: s,
        isMaxUnhiddenCamerasOn: !isMaxUnhiddenCamerasOn ? false : isMaxUnhiddenCamerasOn(s) // This component is re-used, if isMaxUnhiddenCamerasOn is not passed return false otherwise evaluate
        ,

        onCameraToggleClicked: onCameraToggleClicked.bind(null, s),
        isCameraOn: checkCameraIsOn((0, _broadcastSourceHelper.getSourceValue)(s)),
        isMaximumCameraSourcesOn: isMaximumCameraSourcesOn,
        isStaged: stagedSources[s._id],
        onSourceStaged: onSourceStaged.bind(null, s),
        isStagedSourcesActive: isStagedSourcesActive,
        onReorderSources: onReorderSources,
        onDragSource: onDragSource,
        isDraggingSource: isDraggingSource,
        prevSource: idx > 0 ? sources[idx - 1] : {},
        onThumbnailReady: onThumbnailReady.bind(null, s),
        onUploadClicked: onUploadClicked.bind(null, s),
        onSetSourceUnassigned: onSetSourceUnassigned.bind(null, s),
        user: user,
        viewPermissions: viewPermissions,
        attendeeTiles: attendeeTiles,
        meetingSession: meetingSession,
        isDirectorSource: s.value === attendeeId,
        onAssignSpeakers: onAssignSpeakers.bind(null, s),
        onReplaceSlides: onReplaceSlides.bind(null, s),
        onPdfAssignClicked: onPdfAssignClicked.bind(null, s),
        onPresentationLoadSuccess: onPresentationLoadSuccess.bind(null, s),
        onGoToPresentationPage: onGoToPresentationPage.bind(null, s),
        layout: layout
      }));
    });
  }, [visibleItemsMap, sources, liveSources, mediaPlayerSettings, isMaximumCameraSourcesOn, stagedSources, isStagedSourcesActive, isDraggingSource, onSourceSetToLive, onSourceEdited, onSourceDeleted, onSourceHidden, onFeaturedToggleClicked, onMuteToggleClicked, onLiveToggleClicked, onLoopToggleClicked, onVolumeChanged, isMaxUnhiddenCamerasOn, onCameraToggleClicked, onSourceStaged, onReorderSources, onDragSource, onThumbnailReady, onUploadClicked, checkCameraIsOn, enableFeature, onSetSourceUnassigned]);
  return _react["default"].createElement(_contexts.ParamsContext.Provider, {
    value: params
  }, _react["default"].createElement(_DndProvider["default"], null, _react["default"].createElement(_SourceListDnd["default"], null, _react["default"].createElement(_react["default"].Fragment, null, !hasSources && _react["default"].createElement(_SourceList.StyledTextWrapper, null, _react["default"].createElement(_SourceList.StyledText, {
    isStudioLite: isStudioLite
  }, emptyText)), hasSources && displayListComponent(errorBoundaryProps)))));
};
SourceList.propTypes = {
  enableFeature: _propTypes.bool,
  tab: _propTypes.string,
  sources: _propTypes.array.isRequired,
  onSourceSetToLive: _propTypes.func.isRequired,
  onSourceEdited: _propTypes.func.isRequired,
  onSourceDeleted: _propTypes.func.isRequired,
  onFeaturedToggleClicked: _propTypes.func.isRequired,
  onMuteToggleClicked: _propTypes.func.isRequired,
  liveSources: _propTypes.array,
  onSourceHidden: _propTypes.func,
  onLiveToggleClicked: _propTypes.func.isRequired,
  onLoopToggleClicked: _propTypes.func.isRequired,
  mediaPlayerSettings: _MediaPlayerSettingsPropType["default"],
  onVolumeChanged: _propTypes.func.isRequired,
  attendeeMuteStatus: _propTypes.object,
  isMaxUnhiddenCamerasOn: _propTypes.func,
  onCameraToggleClicked: _propTypes.func.isRequired,
  attendeeCameraStatus: _propTypes.object,
  isMaximumCameraSourcesOn: _propTypes.bool,
  stagedSources: _propTypes.object,
  onSourceStaged: _propTypes.func.isRequired,
  isStagedSourcesActive: _propTypes.bool,
  onReorderSources: _propTypes.func.isRequired,
  onDragSource: _propTypes.func.isRequired,
  isDraggingSource: _propTypes.bool,
  onThumbnailReady: _propTypes.func,
  onUploadClicked: _propTypes.func,
  onSetSourceUnassigned: _propTypes.func,
  viewPermissions: _propTypes.object,
  user: _propTypes.object,
  attendeeTiles: _propTypes.object,
  meetingSession: _propTypes.object,
  params: _propTypes.object,
  attendeeId: _propTypes.string,
  onAssignSpeakers: _propTypes.func,
  onReplaceSlides: _propTypes.func,
  onPresentationLoadSuccess: _propTypes.func,
  onGoToPresentationPage: _propTypes.func
};
var _default = exports["default"] = (0, _react.memo)(SourceList, _propComparators.equalityComparator);